import React, { useState } from 'react'
import styled, { useTheme } from 'styled-components';
import { StyledLabel } from '../../assets/styledComponents/Global';
import { getAddressStringByGoogleLocation } from '../job/creation/assets/jobCreationUtill';
import LocationIcon from '../../app/components/svgIcons/LocationIcon';
import CompanyProfileIcon from '../../app/components/svgIcons/CompanyProfileIcon';
import JobsIcon from '../../app/components/svgIcons/JobsIcon';
import { formateLocalNumber, getCurrencySign, toTitleCase } from '../../utils/helper';
import WalletIcon from '../../app/components/svgIcons/WalletIcon';
import ProfileVideoHeader from './ProfileVideoHeader';
import OccyIcon from '../../app/components/svgIcons/OccyIcon';

const ProfileVideoJobDetails = () => {

  const theme = useTheme();
  const companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
  const component = JSON.parse(localStorage.getItem('component'));
  const hiringPlan =  component === 'Referee' || component === 'RefereeForm' ? companyInfo?.application?.job?.jobHiringPlan[0] : companyInfo?.data?.applicationSourceTracking?.jobHiringPlan;
  const company =  component === 'Referee' || component === 'RefereeForm' ? companyInfo?.company : companyInfo?.data?.job?.company;
    const candidate = companyInfo?.application?.candidate;

  function htmlToPlainText(html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
  }
  const [expanded, setExpanded] = useState(false);
  const ReadMoreText = (html, limit = 150) => {

    const text = htmlToPlainText(html);
    const isLong = text.length > limit;
    const displayText = expanded ? text : text.slice(0, limit) + (isLong ? "..." : "");

    return (
      <div>
        <span>{displayText}</span>
        {isLong && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="btn btn-link p-0 ms-1"
            style={{ fontSize: "14px" }}
          >
            {expanded ? "Read Less" : "Read More"}
          </button>
        )}
      </div>
    );
  };
  return (<div className='d-flex flex-column'>
    <ProfileVideoHeader  companyInfo={companyInfo} />
    <CompanyInfoSideBar  >
      <div className={'d-flex flex-column bg-white px-2 py-2'}>

        <StyledLabel size='22px' weight='400' color={theme?.darktext} className=' font-fredoka fw-normal'> {component === 'Referee' ? companyInfo?.application?.job?.title : component === 'RefereeForm' ? candidate?.firstName + candidate?.lastName : companyInfo?.data?.job?.title} </StyledLabel>
      </div>

      <div className={'p-2 h-100'}>
        <div className={'bg-white rounded h-100'}>

          <StyledLabel size='14px' weight='500' color={theme?.subText} style={{ height: expanded && '300px' }} className={`mb-2 overflow-y-auto mt-1 `}>  {ReadMoreText(component === 'Referee' ? companyInfo?.application?.job?.jobDescription : component === 'RefereeForm' ?`${candidate?.firstName + candidate?.lastName} is the person who send you this refernce check form`: companyInfo?.data?.job?.jobDescription)}    </StyledLabel>

          <div className='d-flex align-items-center gap-2 mb-3'>
            <IconBg>
              <LocationIcon size='18' />
            </IconBg>
            <StyledLabel size='14px' weight='500' color={theme?.darktext}> {getAddressStringByGoogleLocation(hiringPlan?.centralLocation, ['address', 'postaltown', 'postalCode'])}    </StyledLabel>

          </div>

          <div className='d-flex align-items-center gap-2 mb-3'>
            <IconBg> <CompanyProfileIcon size='18' /> </IconBg>
            <StyledLabel size='14px' weight='500' color={theme?.darktext}> {company?.name} </StyledLabel>

          </div>
          <div className='d-flex align-items-center gap-2 mb-3'>
            <IconBg>  <JobsIcon color={theme?.primary} size={18} />  </IconBg>
            <StyledLabel size='14px' weight='500' color={theme?.darktext}>{toTitleCase(hiringPlan?.jobType ?? '-')} </StyledLabel>

          </div>
          <div className='d-flex align-items-center gap-2 mb-3'>
            <IconBg>
              <WalletIcon size={18} />
            </IconBg>
            <StyledLabel size='14px' weight='500' color={theme?.darktext}>

              {hiringPlan?.salaryFrom &&
                hiringPlan?.isCompetitive === 0
                ? getCurrencySign(
                  hiringPlan?.salaryCurrency,
                )
                : ' '}
              {hiringPlan?.isCompetitive === 0 &&
                hiringPlan?.salaryFrom > 0 &&
                hiringPlan?.salaryTo > 0
                ? hiringPlan?.salaryFrom ===
                  hiringPlan?.salaryTo
                  ? formateLocalNumber(
                    hiringPlan?.salaryFrom,
                  ) +
                  (hiringPlan?.salaryPeriod
                    ? ' per ' + hiringPlan?.salaryPeriod
                    : '')
                  : formateLocalNumber(
                    hiringPlan?.salaryFrom,
                  ) +
                  ' - ' +
                  getCurrencySign(
                    hiringPlan?.salaryCurrency,
                  ) +
                  formateLocalNumber(
                    hiringPlan?.salaryTo,
                  ) +
                  ' per ' +
                  (hiringPlan?.salaryPeriod == null
                    ? ''
                    : hiringPlan?.salaryPeriod)
                : hiringPlan?.salaryTo > 0 &&
                hiringPlan?.isCompetitive ===
                false &&
                formateLocalNumber(
                  hiringPlan?.salaryFrom,
                ) +
                ' ' +
                (hiringPlan?.salaryPeriod == null
                  ? ''
                  : hiringPlan?.salaryPeriod)}

              {hiringPlan?.salaryFrom &&
                !hiringPlan?.salaryTo &&
                !hiringPlan?.isCompetitive &&
                formateLocalNumber(
                  hiringPlan?.salaryFrom,
                )}
              {!Number(hiringPlan?.salaryFrom) > 0 &&
                'Competitive/negotiable'}

            </StyledLabel>

          </div>

        </div>
      </div>



    </CompanyInfoSideBar>
    <div className='d-flex align-items-center justify-content-center bg-white gap-2 p-3'><OccyIcon size={20} /> <StyledLabel size='13px' weight='500' color={theme?.darktext}>Powered by Occy</StyledLabel> </div>
  </div>
  )
}

export default ProfileVideoJobDetails


const CompanyInfoSideBar = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 30px 20px 27px;
 
        top: 0;
        left: 0;
        height: calc(100vh - 135px);
        background: #fff;
        transition: transform 0.3s ease-in-out;
        z-index: 1050;
      
 
`;

const IconBg = styled.div`
display:flex;
align-items:center;
justify-content:center;
width: 30px;
height: 30px;
angle: 0 deg;
opacity: 1;
border-radius: 107.69px;
background:  ${({ theme }) => theme?.bodyBg};
color:${({ theme }) => theme?.primary};
`